import React from '../../../../_snowpack/pkg/react.js';
import PropTypes from '../../../../_snowpack/pkg/prop-types.js';
import ArrowLeft from '../../../icons/arrow-left.js';
import ArrowRight from '../../../icons/arrow-right.js';

function DatePickerNavBar(props) {
  const {
    labels,
    onPreviousClick,
    onNextClick
  } = props;

  const onNext = () => onNextClick();

  const onPrevious = () => onPreviousClick();

  return /*#__PURE__*/React.createElement("div", {
    className: "DayPicker-NavBar"
  }, /*#__PURE__*/React.createElement("span", {
    "aria-label": labels.previousMonth,
    className: "DayPicker-NavButton DayPicker-NavButton--left",
    onClick: onPrevious,
    role: "button",
    tabIndex: "0"
  }, /*#__PURE__*/React.createElement(ArrowLeft, {
    size: 15
  })), /*#__PURE__*/React.createElement("span", {
    "aria-label": labels.nextMonth,
    className: "DayPicker-NavButton DayPicker-NavButton--right",
    onClick: onNext,
    role: "button",
    tabIndex: "0"
  }, /*#__PURE__*/React.createElement(ArrowRight, {
    size: 15
  })));
}

DatePickerNavBar.propTypes = {
  onNextClick: PropTypes.func,
  onPreviousClick: PropTypes.func,
  labels: PropTypes.shape({
    nextMonth: PropTypes.string.isRequired,
    previousMonth: PropTypes.string.isRequired
  })
};
export default DatePickerNavBar;